<template>
  <div class="bigshot">
    <div class="auto clearfix">
      <div class="title">
        <img src="../assets/image/shot_title.png" alt />
      </div>
      <div class="banner" @mouseleave="leave" @mouseenter="mouse">
        <!-- <div class="jtr" @click="right">
          <img src="../assets/image/jtr.png" alt />
        </div>-->
        <div class="tx_list">
          <ul style="width:2970px">
            <li
              @click="listclick(data,index)"
              :class="{'on':data.clas}"
              v-for="(data,index) in datas"
              :key="index"
            >
              <div class="tx">
                <img :src="data.url" alt />
              </div>
              <span :class="{'on':data.clas}">{{data.name}}</span>
            </li>
            <!-- <li @click="open1">
              <div class="tx">
                <img src="../assets/image/shot_more.png" alt />
              </div>
            </li>-->
          </ul>
        </div>
        <div class="con_box">
          <div
            class="list_box"
            v-bind:class="{oDivdh1:todo.won,oDivdh2:todo.won2}"
            v-show="todo.dis"
            v-for="(todo,index) in subContent"
            :key="index"
          >
            <div class="list_box_con">
              <div class="left_img">
                <el-image :src="todo.src2" class="left_img_image">
                  <div slot="placeholder" class="image-slot">
                    <!-- <img src="../assets/image/timg.gif" alt /> -->
                    加载中
                    <span class="dot">...</span>
                  </div>
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline">加载失败,请刷新重试!</i>
                  </div>
                </el-image>
              </div>
              <div class="right_photographer">
                <div class="tx">
                  <img src="../assets/image/bigtx_bj.png" class="bj" />
                  <img :src="todo.tx_src2" alt class="tou" />
                </div>
                <div class="photographer_introduce">
                  <h3>{{todo.name}}</h3>
                  <p>{{todo.type}}</p>
                </div>
                <a :href="todo.a" target="_blank">
                  <p class="speak">{{todo.speak}}</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: [
        {
          url: require("../assets/image/shot_tx20032001.png"),
          name: "陈海滢",
          clas: true
        },
        {
          url: require("../assets/image/shot_tx20030501.jpg"),
          name: "南山",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx4.jpg"),
          name: "老秘",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112801.jpg?3"),
          name: "杨勇",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx20022502.jpg"),
          name: "西西里",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx20022501.jpg"),
          name: "草原900",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112101.jpg"),
          name: "燕鹏",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19122402.jpg?1"),
          name: "徐阳",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx8.jpg"),
          name: "肖戈",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19122401.jpg"),
          name: "凌子川",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19121302.jpg"),
          name: "老淡",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19121301.jpg"),
          name: "Mo",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112802.jpg"),
          name: "yvlin",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112503.jpg?3"),
          name: "老骆驼",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19120601.jpg?3"),
          name: "比海更蓝",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112502.jpg?3"),
          name: "晚秋之语",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19120201.jpg"),
          name: "徐波",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112501.jpg?3"),
          name: "雨滴",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112102.jpg"),
          name: "蓉儿",
          clas: false
        },

        {
          url: require("../assets/image/shot_tx19112001.jpg"),
          name: "沧海粟",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112002.jpg"),
          name: "村支书",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112003.jpg"),
          name: "米雪飞扬",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx19112004.jpg"),
          name: "豌豆哥哥",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx2.jpg"),
          name: "陈海滢",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx6.jpg"),
          name: "清江水",
          clas: false
        },
        {
          url: require("../assets/image/shot_tx10.jpg"),
          name: "宇哲",
          clas: false
        }
      ],
      subContent: [
        {
          won: true,
          won2: false,
          dis: true,
          src: require("../assets/image/shot_img20032001.gif?123"),
          src2: require("../assets/image/shot_img20032001.gif?123"),
          tx_src: require("../assets/image/shot_bigtx20032001.png"),
          tx_src2: require("../assets/image/shot_bigtx20032001.png"),
          name: "陈海滢",
          a: "http://article.photofans.cn/article-55871-1.html",
          type: "自然与科学摄影师",
          speak:
            "自从EOS R专微推出，佳能RF系统与大家见面已经一年有余，它的设计理念引发了很多摄影师的兴趣。2019年，佳能进一步在RF镜头的产品线上发力，推出了多款颇具亮点的产品。最近试用了RF28-70mm F2 L USM和“RF大三元”中..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img20030601.gif?123"),
          tx_src: require("../assets/image/shot_bigtx20030601.png"),
          name: "南山",
          a: "http://article.photofans.cn/article-55772-1.html",
          type: "知名旅行达人",
          speak:
            "佳能全画幅微单EOS R发售也有段时间了，我也经常带着它一起拍摄，现在算是比较了解这台机器了。在全国都在齐心齐力抵抗新冠病毒的特殊时期，我的出行计划被严重影响，于是决定在家里把这段旅行整理记录一下。罗马尼亚和保..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img20022504.gif?123"),
          tx_src: require("../assets/image/shot_bigtx4.png"),
          name: "老秘",
          a: "http://article.photofans.cn/article-55631-1.html",
          type: "资深商业摄影师",
          speak:
            "佳能专微EOS R也已经发布了有一年多的时间了，我上次使用时机器才刚发布，只试用了套机头与RF2870这只变焦镜头，只能说对它有一个初步的体验，而如今RF85 1.2L与RF 70-200 2.8L IS两只镜头也已陆续上市，我也对EOS R..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img20022503.gif?123"),
          tx_src: require("../assets/image/shot_bigtx112801.png?2"),
          name: "杨勇",
          type: "高级会员",
          a: "http://article.photofans.cn/article-55720-1.html",
          speak:
            "佳能专微EOS R刚发布我就用上了，到现在机器发售也有一年多的时间了，既然能被叫做专微，自然要有着自己的独到之处，比如体积轻巧，再比如能够满足高画质需求的全画幅传感器等，简而言之，对我而言这是一台能放心使用的相机。"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img20022502.gif?123"),
          tx_src: require("../assets/image/shot_bigtx20022502.png"),
          name: "西西里",
          a: "http://article.photofans.cn/article-55634-1.html",
          type: "旅行达人",
          speak:
            "我拿到佳能专微EOS R和RF28-70mm F2 L USM这只镜头有大半年了，带着它们去了五六个国家旅行，周边有不少朋友都会来问关于这台相机和这支镜头的事，在此就来聊聊我使用的感受吧。"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img20022501.gif?123"),
          tx_src: require("../assets/image/shot_bigtx20022501.png"),
          name: "草原900",
          a: "http://article.photofans.cn/article-55632-1.html",
          type: "元老会员",
          speak:
            "虽然现在外出手上拿着手机的时间最多，但是作为一个资深摄影爱好者，我最喜欢的拍摄器材毋容置疑还是单反相机，这几年因为体积重量等原因， 更多人选择了微单相机或是手机，作为一名..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112101.gif"),
          tx_src: require("../assets/image/shot_bigtx112101.png"),
          name: "燕鹏",
          type: "体育摄影师",
          a: "http://article.photofans.cn/article-55633-1.html",
          speak:
            "拍摄激烈的赛事一般都会选用专业的速度机型，从1DX系列到7D系列以及刚发布不久的90D都是不错的选择，但这并不意味着类似于5D4、佳能专微EOS R这样全面均衡的机器就不能胜任拍摄工作。"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img122403.gif"),
          tx_src: require("../assets/image/shot_bigtx122402.png?1"),
          name: "徐阳",
          type: "人文风光摄影家",
          a: "http://article.photofans.cn/article-55272-1.html",
          speak:
            "作为一名摄影人，爱好有时总是让人纠结，每次出游都要考虑带上什么器材，相信大家都有玩遍所有的相机、试遍所有的镜头的想法，但现实是自己只有一双手，最后还是要回归实际，选择一台专业轻便画质好的相机一起出行。"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img122402.gif"),
          tx_src: require("../assets/image/shot_bigtx8.png"),
          name: "肖戈",
          a: "http://article.photofans.cn/article-55273-1.html",
          type: "自然生态摄影家",
          speak:
            "在诸多摄影题材中，生态摄影对于器材的要求可能是最高的：永远需要更长的焦距、更好的画质、更快的连拍、更准的对焦系统。器材哪怕一点点的进步，都能够帮助生态摄影师获得更加精彩的作品。"
        },
        {
          won: false,
          won2: false,
          dis: false,
          src: require("../assets/image/shot_img122401.gif"),
          tx_src: require("../assets/image/shot_bigtx122401.png?2"),
          name: "凌子川",
          type: "资深生态摄影师",
          a: "http://article.photofans.cn/article-55274-1.html",
          speak:
            "佳能专微EOS R推出也有一年多的时间了，大家对它也或多或少有了一些了解，我第一次接触EOS R是用它来拍摄生态的，总体来说有着十..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img121301.gif"),
          tx_src: require("../assets/image/shot_bigtx121302.png?2"),
          name: "老淡",
          type: "元老会员",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1356964",
          speak:
            "常规的开箱照网上已经很多，我就来一组把EOS R融入景色中的开箱照吧。以前使用过5D系列的5D2和5D4，以及1系列的1DX，当我拿到佳能专微EOS R试用了之后就迫不及待的入手了..."
        },
        {
          won: false,
          won2: false,
          dis: false,
          src: require("../assets/image/shot_img121302.gif"),
          tx_src: require("../assets/image/shot_bigtx121301.png?2"),
          name: "Mo",
          type: "元老会员",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1348726",
          speak:
            "EOS R最让人感兴趣的就是使用了和5D4相同的CMOS成像底，5D4一直是我手中的主力作战机型，也是佳能单反中综合性能最为平衡的相机..."
        },
        {
          won: false,
          won2: false,
          dis: false,
          src: require("../assets/image/shot_img112802.gif"),
          tx_src: require("../assets/image/shot_bigtx112802.png?2"),
          name: "yvlin",
          type: "元老会员",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1349756",
          speak:
            "专微是佳能全力打造的新一代数码摄影利器，它以新的切入点重新定义影像系统。基于EOS单反相机长年积累的经验技术，跨越既定思维，配合微单特性改造设计的高画质镜头、强大的..."
        },

        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112503.gif"),
          tx_src: require("../assets/image/shot_bigtx112503.png?2"),
          name: "老骆驼",
          type: "元老会员",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1335909",
          speak:
            "拿到新机佳能EOS R后迫不及待的出去试机，先去了河北涞源烟煤洞拍长城秋色，紧接着马不停蹄的又去了红叶正盛的北京房山坡峰岭拍红叶。佳能EOS R  3030万像素，每秒8张的连拍速度，拍摄中还是实用的。"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img120601.gif"),
          tx_src: require("../assets/image/shot_bigtx120601.png?2"),
          name: "比海更蓝",
          type: "白银会员",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1353579",
          speak:
            "每一张褪色的照片，都好像带给我们一点点怀念。而我家用了37年的衣柜，抽屉里厚厚的照片大多是当年全家挤在宽巷子45号大杂院那间不足20平的老房子时，父亲的拍摄。严格说来，父亲并不是一个纯粹的摄影发烧友..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112502.gif"),
          tx_src: require("../assets/image/shot_bigtx112502.png?2"),
          name: "晚秋之语",
          type: "元老会员",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1339139",
          speak:
            "11月5日第二届中国国际进口博览会在上海隆重开幕！浦江两岸再次上演灯光秀。灯光秀分为三个篇章：《活力上海》《锦绣中华》《欢乐共享》。"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img120201.gif"),
          tx_src: require("../assets/image/shot_bigtx120201.png?2"),
          name: "徐波",
          type: "初级会员",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1351322 ",
          speak:
            "芳香下的餐桌，加上一个靓颖，点缀了生活中的美好情调。这个就是四川人，大多美好的生活开始我用R机器拍摄这个的时候，就用直观的显示屏拍摄..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112501.gif"),
          tx_src: require("../assets/image/shot_bigtx112501.png?2"),
          name: "雨滴",
          type: "北京论坛版主",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1341560",
          speak:
            "拿到佳能EOS RP 就迫不及待的打开包装，装上24-105 F4的变焦头。第二天我就迫不及待的冒雨驾车去了密云古北口水镇，第二个星期六带着孙子来到了京西的戒台寺。"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112103.gif"),
          tx_src: require("../assets/image/shot_bigtx112102.png?1"),
          name: "蓉儿",
          type: "长城论坛版主",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1346085",
          speak:
            "大风过后的下午，我带着佳能全画幅微单EOSR、RF24-105mm F4 L IS USM套机镜头、EF100-400mm f/4.5-5.6L镜头、转接环，去往大营盘长城拍摄日落。因时间关系，这次拍摄中相机设置：图像画质 RAW..."
        },

        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112001.gif"),
          tx_src: require("../assets/image/shot_bigtx112001.png"),
          name: "沧海粟",
          type: "北京版版主",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1342292",
          speak:
            "一直以来，对佳能的广角变焦镜头很关注，早期用16-35/2.8 2代头，后来一直使用11-24mm/4这款灯泡头，特别是后者，无论是在分辨率、色差控制、畸变控制等方面都给我留下了深刻印象..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112002.gif"),
          tx_src: require("../assets/image/shot_bigtx112002.png?1"),
          name: "村支书",
          type: "元老会员",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1345497",
          speak:
            "我一部5D2用了十多年，许久没有更新相机。如今终于升级到了EOS R，上手稍有些陌生，但仔细一看还是熟悉的感觉。打开设置菜单列表，功能更加丰富，但还需要时间慢慢熟悉。轻巧的机身手感非常舒适..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112003.gif"),
          tx_src: require("../assets/image/shot_bigtx112003.png"),
          name: "米雪飞扬",
          type: "摄影佳园版版主",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1342707",
          speak:
            "今秋用EOS R RF50/1.2 人像头 ，迫不及待的约美女哦！说句老实话  ，俺拍人像差点 ，平日里拍的也比较少  ，新机器拿到手里 ，马不停蹄的找题材拍摄 。总体来讲 ，微单EOSR  +  50  1.2 镜头，从重量上来讲 ，一只..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img112004.gif"),
          tx_src: require("../assets/image/shot_bigtx112004.png"),
          name: "豌豆哥哥",
          type: "重庆版版主",
          a:
            "https://xcx.photofans.cn/source/xcx/thread/h5/threadDetail.php?tid=1343559",
          speak:
            "嗯，和题目一样，这是一期非常认真的开箱，以致于笔者还没有把它拿在什么好看的地方来几张。当然，打开它的一瞬间也很重要。所以，这一次，笔者就给大家来一次认真的开箱图。本来，这一切都是意外..."
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img2.gif"),
          tx_src: require("../assets/image/shot_bigtx2.png"),
          name: "陈海滢",
          type: "自然与科学摄影师",
          a: "http://article.photofans.cn/article-54545-1.html",
          speak:
            "佳能全画幅专微EOS R是一台具备优良的可操作性和扩展性的设备，是一台可以拿来放心干活的摄影工具，它的翻转屏便利实用，强大的短片功能兼顾了视频与照片的拍摄，在保证画质和操控的前提下带来便携体验。"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img6.gif"),
          tx_src: require("../assets/image/shot_bigtx6.png"),
          name: "清江水",
          type: "人像摄影师",
          a: "http://article.photofans.cn/article-54314-1.html",
          speak:
            "在EOS R的人脸识别和眼控对焦下，你几乎可以完全忽略掉对焦这步工作，全心在构图和捕捉上，对焦点始终牢牢地锁定在主体的脸甚至是眼睛上，0.05秒极速对焦，且合焦准确率非常高！"
        },
        {
          won: false,
          won2: true,
          dis: false,
          src: require("../assets/image/shot_img10.gif"),
          tx_src: require("../assets/image/shot_bigtx10.png"),
          name: "宇哲",
          type: "商业摄影师",
          a: "http://article.photofans.cn/article-54181-1.html",
          speak:
            "小巧轻便，是我对于EOS R最初的感官体验，当然，随着我不断深入的使用这台相机去拍摄，在这个过程中，这台相机表现出的专业品质，给了我很全面的功能支持。我认为，这台相机完全可以称得上是“全能型影像工具”。"
        }
      ],
      timer: null,
      index: null,
      // 定时器时间
      time: 3000,
      // 便宜量
      wid: null,
      left: null
    };
  },
  mounted() {
    //当前的index
    var index = 0;
    const banerlength = this.datas.length - 1;

    this.timer = setInterval(() => {
      this.wid = (banerlength + 1) * 114;
      if (index == banerlength) {
        index = 0;
        this.dynamic(index);
        return;
      } else {
        index++;
        this.dynamic(index);
      }
    }, this.time);
  },
  methods: {
    // right() {
    //   this.left = 114;
    // },
    // 自动轮播
    dynamic(index) {
      // console.log(banerlength);
      // else if (index == banerlength) {
      //   this.left = 0;
      // }

      // 头像自动轮播
      for (let key in this.datas) {
        this.datas[key].clas = false;
      }
      this.datas[index].clas = true;

      //内容自动轮播
      for (let key2 in this.subContent) {
        this.subContent[key2].won = false;
        this.subContent[key2].won2 = true;
        // 延迟头像和图片加载
        this.subContent[key2].src2 = this.subContent[key2].src;
        this.subContent[key2].tx_src2 = this.subContent[key2].tx_src;
      }
      this.subContent[index].dis = true;
      this.subContent[index].won = true;
      this.subContent[index].won2 = false;

      // ul的left值
      // var banerlength = this.datas.length - 1;
      // console.log(banerlength)
      // if (index > 9 && index < banerlength) {
      //   this.left += 114;
      // } else if (index == 0) {
      //   this.left = 0;
      // }
    },
    listclick(data, index) {
      // 循环头像 并且给不是当前点击的头像去掉样式
      for (let key in this.datas) {
        this.datas[key].clas = false;
      }

      // 给当前头像加上样式
      data.clas = true;
      // 给对应的内容显示
      for (let key2 in this.subContent) {
        this.subContent[key2].won = false;
        this.subContent[key2].won2 = true;
        // 延迟头像和图片加载
        this.subContent[key2].src2 = this.subContent[key2].src;
        this.subContent[key2].tx_src2 = this.subContent[key2].tx_src;
        // this.subContent[key2].dis = false;
      }
      this.subContent[index].dis = true;
      this.subContent[index].won = true;
      this.subContent[index].won2 = false;
      this.index = index;
    },
    //鼠标移动进来清除自动轮播定时器
    mouse() {
      clearInterval(this.timer);
      this.timer = null;
      const index = this.datas.findIndex(todo => {
        return todo.clas == true;
      });
      this.index = index;
    },
    // 鼠标移开继续创建一个定时器
    leave() {
      var index = this.index;
      const banerlength = this.datas.length - 1;
      this.timer = setInterval(() => {
        if (index == banerlength) {
          index = 0;
          this.dynamic(index);
          return;
        } else {
          index++;
          this.dynamic(index);
        }
      }, this.time);
    }
    // open1() {
    //   this.$message({
    //     showClose: true,
    //     message: "当前只有这么多了!",
    //     type: "warning"
    //   });
    // }
  }
};
</script>
<style scoped>
.bigshot {
  float: left;
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 50px;
  background: #fefefe;
}
.bigshot .auto {
  margin: 0 auto;
  width: 1300px;
  height: 100%;
}
.title {
  float: left;
  width: 100%;
}
.title img {
  float: left;
  width: 100%;
}
.banner {
  position: relative;
  float: left;
  width: 100%;
  overflow: hidden;
}
.banner .jtr {
  position: absolute;
  right: 0;
  top: 14%;
  transform: translateY(-50%);
  width: 23px;
  cursor: pointer;
}
.tx_list {
  position: relative;
  float: left;
  /* margin-left: 2%; */
  width: 100%;
  /* width: 100%; */
  height: 150px;
  margin-top: 50px;
  overflow-x: auto;
}

.tx_list .jtr img {
  float: left;
  width: 100%;
}
.tx_list ul,
.tx_list ul li {
  float: left;
}

/* .tx_list ul li:nth-child(12n) {
  margin-top: 10px;
} */

.tx_list ul {
  position: absolute;
  left: 0;
  top: 0;
  height: 122px;
  /* width: 9999%; */
}
.tx_list ul li {
  margin-right: 18px;
  width: 96px;
  cursor: pointer;
}
.tx_list ul li .tx {
  float: left;
  width: 100%;
  border-radius: 50%;
  overflow: hidden;
}
.tx_list ul li.on .tx {
  box-sizing: border-box;
  border: 3px solid #b5a076;
  background: #fff;
}
.tx_list ul li img {
  float: left;
  width: 100%;
}
.tx_list ul li span {
  float: left;
  width: 100%;
  font-size: 16px;
  text-align: center;
  color: #333;
  margin-top: 10px;
}
.tx_list ul li span.on {
  color: #bfa75d;
}
.con_box {
  position: relative;
  float: left;
  margin-top: 50px;
  width: 100%;
  min-height: 520px;
}
.list_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.list_box_con {
  float: left;
  position: relative;
  width: 100%;
}
.con_box .left_img {
  float: left;
  /* margin-top: 25px; */
  width: 780px;
  height: 496px;
}
.left_img_image {
  float: left;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: box;
  -webkit-box-align: center;
  -moz-box-align: center;
  box-align: center;
  -webkit-box-pack: center;
  -moz-box-pack: center;
  box-pack: center;
}
.right_photographer {
  position: absolute;
  width: 470px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  /* height: 520px; */
}
.right_photographer .tx {
  float: left;
  position: relative;
  width: 254px;
  height: 270px;
}
.right_photographer .tx .bj {
  position: absolute;
  top: 7px;
  right: 8px;
}
.right_photographer .tx .tou {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}
.right_photographer .photographer_introduce {
  position: absolute;
  left: 250px;
  top: 150px;
  z-index: 20;
}
.right_photographer .photographer_introduce h3 {
  font-size: 42px;
  color: #bfa75d;
  font-weight: bold;
}
.right_photographer .photographer_introduce p {
  margin-top: 15px;
  font-size: 27px;
  color: #000;
}
.right_photographer .speak {
  float: right;
  margin-top: 18px;
  font-size: 18px;
  color: #000;
  line-height: 34px;
}

.oDivdh1 {
  animation: dw1ain 1s 1;
  -moz-animation: dw1ain 1s 1;
  -webkit-animation: dw1ain 1s 1;
  -o-animation: dw1ain 1s 1;
  animation-fill-mode: forwards;
  z-index: 20;
}

.oDivdh2 {
  animation: dw2ain 1s 1;
  -moz-animation: dw2ain 1s 1;
  -webkit-animation: dw2ain 1s 1;
  -o-animation: dw2ain 1s 1;
  animation-fill-mode: forwards;
  z-index: 0;
}

@-webkit-keyframes dw1ain {
  0% {
    bottom: -5%;
    transform: scale(1.07);
    -webkit-transform: scale(1.07);
    opacity: 0;
    z-index: 20;
  }
  100% {
    bottom: 0;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
    z-index: 20;
  }
}

@-moz-keyframes dw1ain {
  0% {
    bottom: -5%;
    transform: scale(1.07);
    -webkit-transform: scale(1.07);
    opacity: 0;
    z-index: 20;
  }
  100% {
    bottom: 0;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
    z-index: 20;
  }
}

@-o-keyframes dw1ain {
  0% {
    bottom: -5%;
    transform: scale(1.07);
    -webkit-transform: scale(1.07);
    opacity: 0;
    z-index: 20;
  }
  100% {
    bottom: 0;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
    z-index: 20;
  }
}

@keyframes dw1ain {
  0% {
    bottom: -5%;
    transform: scale(1.07);
    -webkit-transform: scale(1.07);
    opacity: 0;
    z-index: 20;
  }
  100% {
    bottom: 0;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
    z-index: 20;
  }
}

@-webkit-keyframes dw2ain {
  0% {
    bottom: 0;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
  }
  100% {
    bottom: -5%;
    transform: scale(1.07);
    -webkit-transform: scale(1.07);
    opacity: 0;
  }
}

@-moz-keyframes dw2ain {
  0% {
    bottom: 0;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
  }
  100% {
    bottom: -5%;
    transform: scale(1.07);
    -webkit-transform: scale(1.07);
    opacity: 0;
  }
}

@-o-keyframes dw2ain {
  0% {
    bottom: 0;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
  }
  100% {
    bottom: -5%;
    transform: scale(1.07);
    -webkit-transform: scale(1.07);
    opacity: 0;
  }
}

@keyframes dw2ain {
  0% {
    bottom: 0;
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 1;
  }
  100% {
    bottom: -5%;
    transform: scale(1.07);
    -webkit-transform: scale(1.07);
    opacity: 0;
  }
}
</style>